// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xKT1","select":"styles_select__17e_o"};